import React from 'react'

import { Fieldset, RadioButton, Subsection, Tooltip } from '@fourthwall/components'

import { Usage } from '../../types'

export const DisabledFields = () => (
  <Subsection title="Welcome post">
    <Fieldset>
      <Fieldset.Row>
        <Fieldset.Item>
          Show your members a little love with a personal welcome post that appears to your
          supporters when they join.
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <RadioButton label="Don’t use welcome post" value={Usage.none} checkedValue={Usage.none} />
      </Fieldset.Row>
      <Fieldset.Row>
        <Tooltip
          placement="top"
          reference={<RadioButton label="Use the same welcome post for each tier" disabled />}
        >
          You need to create membership tiers first.
        </Tooltip>
      </Fieldset.Row>
      <Fieldset.Row>
        <Tooltip
          placement="top"
          reference={<RadioButton label="Use different welcome post for each tier" disabled />}
        >
          You need to create membership tiers first.
        </Tooltip>
      </Fieldset.Row>
    </Fieldset>
  </Subsection>
)
